export enum FinancialVendorStatus {
    New = 1,
    Active = 2,
    Closed = 3,
    InActive = 4,
    Deleted = 5
}